import { createSlice } from '@reduxjs/toolkit';

const initialSolutionSliceState =
{
    solutions: [],
    missions:[]
};

const SolutionSlice = createSlice({
    name: 'solution',
    initialState: initialSolutionSliceState,
    reducers: {
        setSolutionSlice(state, action) {
            state.solutions = action.payload;
        },

    },
});

export default SolutionSlice;